import { render, staticRenderFns } from "./GradientBox.vue?vue&type=template&id=2fe3a974&scoped=true&"
import script from "./GradientBox.vue?vue&type=script&lang=js&"
export * from "./GradientBox.vue?vue&type=script&lang=js&"
import style0 from "./GradientBox.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./GradientBox.vue?vue&type=style&index=1&id=2fe3a974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe3a974",
  null
  
)

export default component.exports